exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".disclosure-1-t6S {\n  font-size: 10px;\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"disclosure": "disclosure-1-t6S"
};